module.exports = __webpack_public_path__ + "img/9.77ecefc1.jpg";